import type { SearchRequest } from "@tsmono/inspect-common/types";

import type { SearchResultScope, SearchScope, SearchType } from "./types";

export type { SearchScope, SearchType } from "./types";

export type GrepOptions = {
  ignoreCase: boolean;
  regex: boolean;
  wordBoundary: boolean;
};

type BuildSearchRequestOptions = {
  grepOptions: GrepOptions;
  model: string;
  query: string;
  scope: SearchScope;
  searchType: SearchType;
};

export const buildSearchScope = (scope: SearchScope): SearchResultScope => {
  return scope === "messages" ? { messages: "all" } : { events: "all" };
};

export const buildSearchRequest = ({
  grepOptions,
  model,
  query,
  scope,
  searchType,
}: BuildSearchRequestOptions): SearchRequest => {
  const scopeFields = buildSearchScope(scope);

  if (searchType === "grep") {
    return {
      ...scopeFields,
      ignore_case: grepOptions.ignoreCase,
      query,
      regex: grepOptions.regex,
      type: "grep",
      word_boundary: grepOptions.wordBoundary,
    };
  }

  return {
    ...scopeFields,
    model: model || null,
    query,
    type: "llm",
  };
};
